export default "__VITE_ASSET__BLQOkypw__"